import React from 'react';

const RequiredTag = () => {

    return(
        <span className='text-danger font-weight-bold'>*</span>
    )
}

export default RequiredTag;